type ButtonTypes = {
  BOLD: 'bold';
  ITALIC: 'italic';
  UNDERLINE: 'underline';
  LIST: 'list';
  BULLET: 'bullet';
};
const buttonTypes: ButtonTypes = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  LIST: 'list',
  BULLET: 'bullet'
};

// TODO: Figure out what to do with the "type" values duplication
type ToolbarButtonProps = {
  type: 'bold' | 'italic' | 'underline' | 'list' | 'bullet';
};

function ToolbarButtonImpl({ type }: ToolbarButtonProps) {
  const className = `ql-format-button ql-${type}`;
  return <span className={className} />;
}

// `ToolbarButton.types` is consumed by callers as the source of valid `type`
// values (e.g. `ToolbarButton.types.BOLD`) — Object.assign attaches it to the
// function so the external API stays the same as the class original's
// `static types`.
export const ToolbarButton = Object.assign(ToolbarButtonImpl, {
  displayName: 'RichTextEditor_ToolbarButton',
  types: buttonTypes
});
